import { isElementBuilder, isViewBuilder } from "./other.js";
/**
 * Extracts the element declaration from a builder.
 */
export function isBuilder(value) {
    return isViewBuilder(value) || isElementBuilder(value);
}
